import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Loader, Paper } from 'redpoints-front-components/index';
import { NoResult, withContext } from 'redpoints-front-common/components';

import {
  getTestPurchaseLinkInfoIsLoading,
  getTestPurchaseLinkInfoLinkId,
} from '../../../reducers/tasks/testPurchase';
import TestPurchaseActions from './TestPurchaseActions';
import TestPurchaseAddress from './TestPurchaseAddress';
import TestPurchaseEvidences from './TestPurchaseEvidences';
import TestPurchaseLinkInfo from './TestPurchaseLinkInfo';
import NoFilterApplied from '../../../components/NoFilterApplied';
import { translate } from '../../../helpers/languageHelper';

import './testPurchaseDisplayer.less';

const TestPurchaseDisplayer = ({ isLoading, linkId, hasFiltersApplied }) => {
  if (isLoading) {
    return <Loader isLoading />;
  }

  const isLinkLoaded = linkId != null;

  if (!isLinkLoaded) {
    if (hasFiltersApplied) {
      return (
        <NoResult
          text={translate('common.no_more_results')}
          subtext={translate('common.enjoy')}
        />
      );
    }

    return (
      <NoFilterApplied
        title={translate('common.no_filter')}
        description={translate('common.no_filter_description')}
      />
    );
  }

  return (
    <div className="test-purchase-displayer">
      <TestPurchaseLinkInfo />
      <Paper>
        <TestPurchaseAddress />
        <TestPurchaseEvidences />
      </Paper>
      <TestPurchaseActions />
    </div>
  );
};

const mapStateToProps = state => ({
  isLoading: getTestPurchaseLinkInfoIsLoading(state),
  linkId: getTestPurchaseLinkInfoLinkId(state),
});

export default compose(
  withContext,
  connect(mapStateToProps),
  memo
)(TestPurchaseDisplayer);
